import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, DatePicker, message, Popover, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import { FaAngleDown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import transactionActions from "../../redux/transactions/actions";
import moment from "moment";
import { generateFilename } from "../../utils/exportFileName";
import { Link } from "react-router-dom";
import { BlobFileDownload } from "./BlobFileDownload";
import actions from '../../redux/notifications/actions'
import { toast, } from "react-toastify";

const TransactionExport = ({ selectedFromDate, selectedToDate }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [fileExportMessage, setFileExportMessage] = useState('')
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const { getAllTransactionsData, resetAllTransactionsData } =
    transactionActions;
  const { profileData } = useSelector((state) => {
    return {
      profileData: state.authReducer.profileData,
    };
  });

  const { transactionData, allTransactions, agentId } = useSelector((state) => {
    return {
      agentId: state.authReducer.agentId,
      transactionData: state.transactionReducer?.transactionData,
      allTransactions: state.transactionReducer?.allTransactions,
    };
  });

  //   dynamic cols
  const getDynamicColumns = (transactions) => {
    const tags = [];

    // Iterate over all transactions to collect tags
    transactions?.forEach((transaction) => {
      transaction?.customerParams?.tag?.forEach((tag) => {
        // Avoid duplicates by checking if the tag name already exists
        if (!tags.some((existingTag) => existingTag?.name === tag?.name)) {
          tags.push(tag);
        }
      });
    });

    // Map tags to columns
    return tags?.map((tag) => ({
      title: tag?.name,
      dataIndex: tag?.name,
    }));
  };

  // Memoize the dynamic columns to avoid recalculating on every render
  const dynamicColumns = useMemo(
    () => getDynamicColumns(transactionData?.transactions),
    [transactionData]
  );

  const exportData =
    transactionData?.data?.transactions &&
    transactionData?.data?.transactions?.length > 0 &&
    transactionData?.data?.transactions?.map((items, index) => {
      // Treating customerParams?.tag as an array
      const customerTags = items?.customerParams?.tag || [];

      // Create an object with the static data
      let rowData = {
        TransactionDateTime: items?.createdAt,
        TransactionId: items?.transactionId,
        // ParticipantCode: items?.ParticipantCode,
        PaymentMode: items?.paymentMode,
        Biller: items?.biller?.billerName,
        "BillAmount (₹)": items?.billAmount ? items?.billAmount / 100 : "",
        "PaidAmount (₹)": items?.amount ? items?.amount / 100 : "",
        // IdfReceiptNumber: items?.idfrecieptnumber || "",
        BillerCategory: items?.biller?.billerCategoryName,
        // EnTransId: items?.EnTransId || "",
        // BillerId: items?.billerId,
        TranStatus:
          items?.status.toLowerCase() === "successful" &&
            items?.cuResponse?.toLowerCase() === "successful"
            ? "Successful"
            : items?.status.toLowerCase() === "pending" ||
              items?.cuResponse?.toLowerCase() === "pending"
              ? "Pending"
              : "Failure",
        ResponseMsg:
          items?.status.toLowerCase() === "successful" &&
            items?.cuResponse?.toLowerCase() === "successful"
            ? "Successful"
            : items?.status.toLowerCase() === "pending" ||
              items?.cuResponse?.toLowerCase() === "pending"
              ? "Pending"
              : "Failure",
      };

      // Dynamically add each tag value to the rowData
      customerTags.forEach((tag) => {
        rowData[tag?.name] = tag?.value;
      });

      // Now include the dynamic columns in the export data
      return {
        ...rowData,
        ...dynamicColumns.reduce((acc, column) => {
          // Search for the tag that matches the column name (title)
          const tagValue = customerTags.find(
            (tag) => tag?.name === column?.title
          );
          // If tag value is found, add it, otherwise add an empty string
          if (tagValue) {
            acc[column?.title] = tagValue?.value || "";
          } else {
            acc[column?.title] = "";
          }
          return acc;
        }, {}),
      };
    });

  const exportAllTransactions =
    allTransactions?.data?.transactions &&
    allTransactions?.data?.transactions?.length > 0 &&
    allTransactions?.data?.transactions?.map((items, index) => {
      // Treating customerParams?.tag as an array
      const customerTags = items?.customerParams?.tag || [];

      // Create an object with the static data
      let rowData = {
        TransactionDateTime: items?.createdAt,
        TransactionId: items?.transactionId,
        // ParticipantCode: items?.ParticipantCode,
        PaymentMode: items?.paymentMode,
        Biller: items?.biller?.billerName,
        "BillAmount (₹)": items?.billAmount ? items?.billAmount / 100 : "",
        "PaidAmount (₹)": items?.amount ? items?.amount / 100 : "",
        // IdfReceiptNumber: items?.idfrecieptnumber || "",
        BillerCategory: items?.biller?.billerCategoryName,
        // EnTransId: items?.EnTransId || "",
        // BillerId: items?.billerId,
        TranStatus:
          items?.status?.toLowerCase() === "successful" &&
            items?.cuResponse?.toLowerCase() === "successful"
            ? "Successful"
            : items?.status?.toLowerCase() === "pending" ||
              items?.cuResponse?.toLowerCase() === "pending"
              ? "Pending"
              : "Failure",
        ResponseMsg:
          items?.status?.toLowerCase() === "successful" &&
            items?.cuResponse?.toLowerCase() === "successful"
            ? "Successful"
            : items?.status?.toLowerCase() === "pending" ||
              items?.cuResponse?.toLowerCase() === "pending"
              ? "Pending"
              : "Failure",
      };

      // Dynamically add each tag value to the rowData
      customerTags.forEach((tag) => {
        rowData[tag?.name] = tag?.value;
      });

      // Now include the dynamic columns in the export data
      return {
        ...rowData,
        ...dynamicColumns.reduce((acc, column) => {
          // Search for the tag that matches the column name (title)
          const tagValue = customerTags.find(
            (tag) => tag?.name === column?.title
          );
          // If tag value is found, add it, otherwise add an empty string
          if (tagValue) {
            acc[column?.title] = tagValue?.value || "";
          } else {
            acc[column?.title] = "";
          }
          return acc;
        }, {}),
      };
    });
  // const handleFullSheetExport = (date) => {
  //   setfromDate(date);
  // };

  //   disable date
  // const disabledToDate = (current) => {
  //   return (
  //     (fromDate &&
  //       current &&
  //       (current < fromDate.startOf("day") ||
  //         current > moment().startOf("day"))) ||
  //     (current && current > moment().startOf("day"))
  //   );
  // };

  const handleFromDateChange = (date) => {
    if (
      date?.isSame(moment(), "day") &&
      (date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second()))
    ) {
      setFromDate(
        date
          .clone()
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
      );
    } else {
      setFromDate(date);
    }
    if (date > toDate) {
      setToDate(null);
    }
  };
  const handleToDateChange = (date) => {
    if (date?.isAfter(moment(), "day")) {
      setToDate(moment());
    } else if (date?.isSame(moment(), "day")) {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.isSame(fromDate, "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second())
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else {
        setToDate(date);
      }
    } else {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(date.clone().hour(23).minute(59).second(59));
      } else {
        setToDate(date);
      }
    }
    if (date && date < fromDate) {
      setFromDate(null);
    }
  };

  const disabledFromDate = (current) => {
    return (
      (fromDate && current && current < fromDate?.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

  const disabledToDate = (current) => {
    return (
      (fromDate && current < fromDate.startOf("day")) ||
      current > moment().endOf("day")
    );
  };


  // const disabledTime = () => {
  //   const now = moment();
  //   return {
  //     disabledHours: () =>
  //       Array.from({ length: 24 }, (_, i) => i).filter((hour) => hour > now.hour()),

  //     disabledMinutes: (selectedHour) => {
  //       if (selectedHour === now.hour()) {
  //         return Array.from({ length: 60 }, (_, i) => i).filter(
  //           (minute) => minute > now.minute()
  //         );
  //       }
  //       return [];
  //     },
  //   };
  // };

  const disabledTime = (currentDate) => {
    const now = moment();
    if (currentDate.isSame(now, 'day')) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour > now.hour()
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute > now.minute()
            );
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };


  // useEffect(() => {
  //   if (fromDate !== null) {
  //     dispatch(
  //       getAllTransactionsData(
  //         1,
  //         "",
  //         "",
  //         fromDate?.format("YYYY-MM-DD"),
  //         fromDate?.format("YYYY-MM-DD"),
  //         agentId
  //       )
  //     );
  //   }
  // }, [fromDate]);

  useEffect(() => {
    if (
      allTransactions?.loading === false &&
      (allTransactions?.error !== null || allTransactions?.data?.total === 0)
    ) {
      setTimeout(() => {
        dispatch(resetAllTransactionsData());
      }, 3000);
      setFromDate(null);
    } else if (
      allTransactions?.loading === false &&
      allTransactions?.error === null &&
      allTransactions?.data?.total !== 0 &&
      fromDate !== null
    ) {
      setTimeout(() => {
        dispatch(resetAllTransactionsData());
      }, 20000);
      setFromDate(null);
    }
  }, [allTransactions]);

  // Trigger export when fromDate changes
  // useEffect(() => {
  // if (fromDate && fromDate.format("YYYY-MM-DD")) {
  //   const fileUrl = `${
  //     process.env.REACT_APP_RECON_API_BASE_URL
  //   }api/cou-dashboard/transactions/export-data?fromDate=${fromDate.format(
  //     "YYYY-MM-DD"
  //   )}&toDate=${fromDate.format("YYYY-MM-DD")}${
  //     agentId ? `&agentId=${agentId}` : ""
  //   }`;
  useEffect(() => {
    if (fromDate && fromDate.format("YYYY-MM-DD") && toDate && toDate.format("YYYY-MM-DD")) {
      const fileUrl = `${process.env.REACT_APP_RECON_API_BASE_URL
        }api/cou-dashboard/transactions/export-data?fromDate=${encodeURIComponent(fromDate?.format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        ))}&toDate=${encodeURIComponent(toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"))}${profileData?.orgId ? `&agentId=${profileData?.orgId}` : ''}`;

      setExporting(true); // Start exporting, set loading message to show

      BlobFileDownload(fileUrl, sessionStorage.getItem("biller_access"))
        .then((response) => {
          // Handle successful response
          if (response.msg === "Download successful") {
            setExporting(false);
            setFileExportMessage('File Exported!')
            setTimeout(() => {
              setFileExportMessage('')
            }, 3000);
            setFromDate(null);
            setToDate(null)
            // messageApi.open({
            //   type: "success",
            //   content: "File Exported Successfully",
            //   duration: 2,

            // });
            // dispatch(actions.addNotification(`${response.downloadUrl}`))
            dispatch(actions.addNotification({
              type: 'download',
              message: 'Transaction file is ready to download',
              url: response.downloadUrl,
            }));
          }
        })
        .catch((error) => {
          // Handle failure response
          setExporting(false);
          setFileExportMessage('File Exported failed!')
          messageApi.open({
            type: "error",
            content: `File export failed: ${error}`,
            duration: 2,
          });
          setTimeout(() => {
            setFileExportMessage('')
          }, 3000);
          console.log(error, "error")
          setFromDate(null)
          setToDate(null)
        });
    }
  }, [fromDate, toDate]);

  const handleTodayExport = async () => {

    if (!selectedFromDate && !selectedToDate) {
      toast.error('Please select the date to export the transaction')
      return;
    }
    const fDate = selectedFromDate.format("YYYY-MM-DDTHH:mm:ssZ");
    const tDate = selectedToDate.format("YYYY-MM-DDTHH:mm:ssZ");

    const fileUrl = `${process.env.REACT_APP_RECON_API_BASE_URL
      }api/cou-dashboard/transactions/export-data?fromDate=${fDate}&toDate=${tDate}`;

    console.log(fileUrl);

    const fetchData = await fetch(fileUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("biller_access")}`,
      },
    })
    const json = await fetchData.json();
    toast.success(json.message)
  };

  return (
    <>
      {contextHolder}
      {/* <div>
        {exportData?.length > 0 ? (
          <Popover
            placement="bottom"
            content={
              <div
                className="exportBtnDiv"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "white",
                  padding: "10px",
                  zIndex: 10,
                  gap: "20px",
                }}
              >
                {exportData?.length > 0 ? (
                  <>
                    {exporting ? (
                      <span
                        className="btn not-allowed hover:not-allowed"
                        style={{ textWrap: "nowrap", textAlign: "center" }}
                      >
                        <DownloadOutlined /> &nbsp; Today
                      </span>
                    ) : (
                      <Button
                      className="btn exportBtn"
                      onClick={handleTodayExport}
                      disabled={exporting}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {exporting
                        ? "Exporting…"
                        : <>
                            <DownloadOutlined /> &nbsp; Today
                          </>
                      }
                    </Button>
                    )}
                    {exporting && fileExportMessage===''&&
                    fromDate !== null ? (
                      <span
                        style={{
                          width: "180px",
                          textAlign: "center",
                        }}
                      >
                        Exporting... <Spin size="16" />
                      </span>
                    ) : (
                      <>
                        {allTransactions?.loading === false &&
                          allTransactions?.data === null && (
                            <>
                              {exporting===false &&
                              fileExportMessage!=='' ? (
                                <span
                                  className="border py-1 rounded"
                                  style={{
                                    width: "180px",
                                    textAlign: "center",
                                    color: `${fileExportMessage==='File Exported!'?'green':'red'}`,
                                  }}
                                >
                                  {fileExportMessage}
                                </span>
                              ) : (
                                <Popover
                                  placement="bottom"
                                  trigger={"click"}
                                  content={
                                    // <DatePicker
                                    //   value={fromDate}
                                    //   style={{
                                    //     width: "100%",
                                    //     border: "none",
                                    //   }}
                                    //   onChange={handleFullSheetExport}
                                    //   disabledDate={disabledToDate}
                                    //   format="DD-MM-YYYY"
                                    //   placeholder="(DD-MM-YYYY)" // Placeholder added here
                                    //   suffixIcon={
                                    //     <CalendarOutlined
                                    //       style={{ color: "#d9d3d3" }}
                                    //     />
                                    //   }
                                    // />
                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                    <DatePicker
                                      value={fromDate}                         
                                      style={{ width: "100%", border: "none" }}
                                      onChange={handleFromDateChange}           
                                      disabledDate={disabledFromDate}             
                                      format="DD-MM-YYYY HH:mm:ss"
                                      showTime
                                      showNow={false}
                                      placeholder="From Date (DD-MM-YYYY HH:mm:ss)"
                                      suffixIcon={<CalendarOutlined style={{ color: "#d9d3d3" }} />}
                                    />
                                    <DatePicker
                                      value={toDate} 
                                      style={{ width: "100%", border: "none" }}
                                      onChange={handleToDateChange}             
                                      disabledDate={disabledToDate}       
                                      format="DD-MM-YYYY HH:mm:ss"
                                      showTime={{
                                        format: "HH:mm:ss",
                                        disabledTime: disabledTime
                                      }}
                                      showNow={false}
                                      placeholder="To Date (DD-MM-YYYY HH:mm:ss)"
                                      suffixIcon={<CalendarOutlined style={{ color: "#d9d3d3" }} />}
                                    />
                                  </div>
                                  }
                                >
                                  <Button
                                    // disabled={
                                    //   alertNotify === true &&
                                    //   (toDate === null ||
                                    //     fromDate === null ||
                                    //     dateDiffDays > 1)
                                    // }
                                    // disabled={true}

                                    style={{
                                      width: "180px",
                                    }}
                                    // onClick={functionToGetAllTransactionsData}
                                  >
                                    Fetch By Date
                                  </Button>
                                </Popover>
                              )}
                            </>
                          )}
                        {allTransactions?.data?.total === 0 &&
                          allTransactions?.loading === false && (
                            <div
                              className="d-flex justify-content-center border rounded py-1"
                              style={{ width: "180px" }}
                            >
                              <span>No data found 😐</span>
                            </div>
                          )}
                      </>
                    )}

                    {allTransactions?.loading === false &&
                      allTransactions?.data?.total !== 0 &&
                      exportAllTransactions?.length > 0 && (
                        <CSVLink
                          filename="fullsheetdata.csv"
                          data={exportAllTransactions}
                          className="btn exportBtn"
                          style={{ textWrap: "nowrap", width: "180px" }}
                        >
                          <DownloadOutlined /> &nbsp; Export Now
                        </CSVLink>
                        // <Button onClick={()=>handleExportFile()}>
                        //   <DownloadOutlined /> &nbsp; Export Sheet
                        // </Button>
                      )}
                  </>
                ) : (
                  <div className="btn not-allowed">
                    <DownloadOutlined />
                    <span>Export</span>
                  </div>
                )}
              </div>
            }
            trigger={"click"}
          >
            <Button
              className="btn exportBtn"
              style={{
                padding: "10",
                border: "1px solid green",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              Export
              <FaAngleDown />
            </Button>
          </Popover>
        ) : (
          <span
            className="btn"
            style={{
              padding: "10",
              gap: "4px",
              border: "1px solid #525252",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              cursor: "not-allowed",
              color: "white",
              backgroundColor: "#525252",
            }}
          >
            <DownloadOutlined />
            Export
          </span>
        )}
      </div> */}

      <div onClick={handleTodayExport}>
        <span
          className="btn"
          style={{
            padding: "10",
            gap: "4px",
            border: "1px solid green",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            // cursor: "not-allowed",
            color: "white",
            backgroundColor: "green",
          }}
        >
          <DownloadOutlined />
          Export
        </span>
      </div>
    </>
  );
};

export default TransactionExport;
